// @ts-nocheck
import useGet from 'hooks/useGet';
import useSave from 'hooks/useSave';
import { useToast } from 'hooks';

const useApiServices = () => {
  const toast = useToast();

  const {
    data: formAnswerById,
    fetch: fetchFormAnswerById,
    loading: loadingFormAnswerById,
  } = useGet('v1.1/submission/:id', {
    customSkipFn: ({ params }) => !params.id,
    transformSuccess: ({ data }) => data?.data,
  });

  const [saveAnswer] = useSave(`v1.1/submission/`, {
    onFailure(message) {
      toast.error(message || 'Error Performing the Action');
    },
  });

  const [updateAnswer] = useSave(
    `v1.1/submission/:id/`,

    {
      method: 'PUT',
      onFailure(message) {
        toast.error(message || 'Error Performing the Action');
      },
    },
  );

  return {
    serverState: {
      formAnswerById,
      loadingFormAnswerById,
    },
    apiActions: {
      fetchFormAnswerById,
      saveAnswer,
      updateAnswer,
    },
  };
};

export default useApiServices;
